import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const removeEmergentBadge = () => {
  const selectors = [
    "#emergent-badge",
    "a[href*='utm_source=emergent-badge']",
    "a[href*='app.emergent.sh']"
  ];
  document.querySelectorAll(selectors.join(",")).forEach((node) => node.remove());
  document.querySelectorAll("a, div, span").forEach((node) => {
    const text = (node.textContent || "").trim();
    if (text === "Made with Emergent") {
      const container = node.closest("a, div");
      if (container) container.remove();
    }
  });
};

removeEmergentBadge();
const emergentObserver = new MutationObserver(removeEmergentBadge);
emergentObserver.observe(document.documentElement, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
